import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Label from '../../../utility/form/Label/LabelField';
import { InputField } from '../../../utility/form';
import LoadingButton from '../../../utility/button/LoadingButton';
import useSupportTicket from './useSupportTicket';
import { useNavigate } from 'react-router-dom';

const SupportModal = ({ closeModal }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl] = useState('');

  const {
    form,
    onChange,
    onSubmit,
    loading,
    errors,
    file,
    handleFileChange,
    resetForm,
    handleClose
  } = useSupportTicket({
    onSuccess: () => setShowSuccess(true),
  });

  const { t } = useTranslation();

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => setPreviewUrl(reader.result);
    reader.readAsDataURL(file);
  };

  const handleThankYouClose = () => {
    resetForm();
    setShowSuccess(false);
    closeModal?.();
  };

  return (
    <div className="modal fade support-modal" id="supportModal" aria-hidden="true" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 overflow-hidden shadow-lg border-0">

          {!showSuccess && <div className="modal-header border-0 px-4 py-3">
            <h5 className="modal-title fw-semibold">{t('login.supportTitle') || 'Support'}</h5>
            <button
              type="button"
              className="btn-close-modal btn-close" 
              onClick={handleThankYouClose}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>}

          <div className="modal-body px-4 py-5">
            <div className="container-fluid">
              <div className="row g-5 align-items-start">
                {showSuccess ? (
                  <div className="col-12 text-center">
                    <div className="">
                      <h1 className="thankyou__heading_new">Thank you!</h1>
                      <p className="thankyou__text mb-1">Your ticket has been submitted successfully.</p>
                      <p className="thankyou__text mt-1">Our support team will get back to you shortly.</p>
                      <button
                        className="btn btn-primary mt-3" 
                        onClick={handleThankYouClose}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >Close</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-md-6">
                      {/* <img
                        src="https://www.shutterstock.com/image-photo/concept-contact-us-customer-support-600nw-2505308177.jpg"
                        alt="Support"
                        className="img-fluid rounded-4 shadow-sm"
                      /> */}
                    </div>

                    <div className="col-md-6">
                      <div className="p-3 p-md-0">
                        <form onSubmit={onSubmit} noValidate>
                          <div className="mb-3">
                            <InputField
                              label={t('login.subject')}
                              name="subject"
                              value={form.subject}
                              onChange={onChange}
                              error={errors.subject}
                              placeholder={t('login.subjectPlaceholder')}
                              type="text"
                            />
                          </div>

                          <div className="mb-3">
                            <InputField
                              label={t('login.message')}
                              name="description"
                              value={form.description}
                              onChange={onChange}
                              error={errors.description}
                              placeholder={t('login.messagePlaceholder')}
                              as="textarea"
                              rows={4}
                            />
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="file" label={t('login.file')} />

                            <div
                              className="upload-box border border-2 rounded-3 p-4 text-center"
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={(e) => {
                                e.preventDefault();
                                const droppedFile = e.dataTransfer.files[0];
                                if (droppedFile) {
                                  previewFile(droppedFile);
                                  handleFileChange({ target: { files: [droppedFile] } });
                                }
                              }}
                              onClick={() => document.getElementById('fileInput').click()}
                              style={{ cursor: 'pointer' }}
                            >
                              {!previewUrl ? (
                                  <p className="text-muted">Drag & drop a file here or click to select</p>
                                ) : (
                                  file?.type?.startsWith("image/") ? (
                                    <img src={previewUrl} alt="Preview" className="img-fluid rounded shadow-sm" style={{ maxHeight: '150px' }} />
                                  ) : (
                                    <p className="small text-muted">
                                      <strong>{file?.name || 'File selected'}</strong><br />(Preview unavailable)
                                    </p>
                                  )
                                )}
                              <input
                                type="file"
                                id="fileInput"
                                name="file"
                                accept="*/*"
                                onChange={(e) => {
                                  const selectedFile = e.target.files[0];
                                  if (selectedFile) {
                                    previewFile(selectedFile);
                                  }
                                  handleFileChange(e);
                                }}
                                style={{ display: 'none' }}
                              />
                            </div>

                            {errors.file && <div className="text-danger mt-1">{errors.file}</div>}
                          </div>

                          <LoadingButton
                            type="submit"
                            disabled={loading}
                            isLoading={loading}
                            className="btn btn-primary w-100 mt-3"
                          >
                            {t('login.support')}
                          </LoadingButton>
                        </form>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SupportModal;
